<template lang='pug' src='./why-choose-us.pug'></template>

<script>
import BlockTestimonial from 'components/block/block-testimonial/block-testimonial'
import Hero from 'components/hero/hero'
import Loader from 'components/loader/loader'
import Intro from 'components/block/block-intro/block-intro'
import BlockRowSection from 'components/block/block-row-section/block-row-section'

export default {
  name: 'why-choose-us',
  data: () => ({

  }),
  computed: {
    props () {
      return this.$store.state.pages['patients']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    BlockTestimonial,
    Loader,
    Hero,
    Intro,
    BlockRowSection
  }
}
</script>



// WEBPACK FOOTER //
// why-choose-us.vue?456273aa